<!-- filepath: c:\Users\YG\Documents\GitHub\suuq\frontend\src\views\PlaceAd.vue -->
<template>
  <div>

   <!-- Main Content -->
    <div class="main-content">
      <v-card elevation="0" width="600" class="mx-auto mt-5">
        <v-card-title class="text-center mb-5">
          Hello, what are you listing today?
          <div class="text-grey text-caption">
            Select the area that best suits your ad
          </div>
        </v-card-title>

        <v-card-text>
          <!-- Categories -->
          <v-row v-if="!loading">
            <v-col
              cols="6"
              md="4"
              v-for="cat in categories"
              :key="cat.id"
              class="d-flex justify-center"
            >
              <v-card
                :width="isMobile ? 300 : 160"
                height="160"
                elevation="3"
                class="my-auto text-center"
                @click="selectCategory(cat)"
              >
             
                <template
                  v-if="
                    showSubs && picked?.slug === 'jobs' && cat.slug === 'jobs'
                  "
                >
                  <v-card-text class="pa-0">
                    <!-- First row: bold, centered -->
                    <div
                      class="job-sub-item text-subtitle-1 font-weight-bold text-center py-8"
                     @click.stop="goToHiring"
                    >
                      {{ subcategories[0]?.title || subcategories[0]?.name }}
                    </div>

                    <v-divider />

                    <!-- Second row: normal weight, centered -->
                    <div
                      class="job-sub-item body-1 font-weight-bold text-center py-4"
                    @click.stop="goToJobSeekers"
                    >
                      {{ subcategories[1]?.title || subcategories[1]?.name }}
                    </div>
                  </v-card-text>
                </template>

                <!-- All other cases: show icon + label -->
                <template v-else>
                  <v-row class="text-center">
                    <v-col cols="12" class="d-flex justify-center mt-10">
                      <v-img
                        :src="require(`@/assets/${cat.slug}.svg`)"
                        alt="icon"
                        max-width="45"
                      />
                    </v-col>
                    <v-col cols="12">
                      <div class="text-caption font-weight-black">
                        {{ cat.name }}
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-card>
            </v-col>
          </v-row>

          <!-- Loading Spinner -->
          <v-row v-if="loading">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>

          <!-- Continue from Drafts Section -->
          <div
            v-if="userDrafts.length"
            class="text-center text-error text-caption mt-5 mb-5"
          >
            OR continue posting from your drafts
          </div>
          <div v-if="userDrafts.length">
            <v-card
              height="60"
              v-for="(draft, index) in userDrafts"
              :key="draft.id"
              class="mt-2"
            >
              <v-card-title class="d-flex">
                <v-avatar
                  color="error"
                  class="mt-3 text-caption font-weight-black"
                  size="x-small"
                >
                  {{ index + 1 }}
                </v-avatar>
                <div class="mt-4 text-caption font-weight-black ml-4">
                  {{ draft.title }}
                </div>
                <v-spacer></v-spacer>
                <div>
                  <v-avatar
                    @click="selectDraftAndNavigate(draft)"
                    class="mt-3"
                    color="grey-lighten-4"
                    size="small"
                  >
                    <v-icon
                      icon="mdi-chevron-right"
                      color="error"
                      size="x-small"
                    ></v-icon>
                  </v-avatar>

                  <v-avatar
                    @click="deleteDraft(draft)"
                    class="mt-3 ml-2"
                    color="grey-lighten-4"
                    size="small"
                  >
                    <v-icon
                      icon="mdi-delete"
                      color="error"
                      size="x-small"
                    ></v-icon>
                  </v-avatar>
                </div>
              </v-card-title>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DraftService from "@/services/draft.services.js";

// Vuex store and router
const store = useStore();
const router = useRouter();

// Reactive state
const loading = ref(true);

const userDrafts = ref([]);
const showSubs = ref(false);
const picked = ref(null);

// Computed properties
// Computed properties
const categories = computed(() => store.getters["NewCategory/categories"]);
const isMobile = computed(() => window.innerWidth <= 768);
const loggedInUser = computed(() => store.state.auth.user || {});
const subcategories = computed(
  () => store.getters["NewCategory/subcategories"]
);

// Fetch categories and drafts on component mount
onMounted(() => {
  fetchCategories();
  fetchUserDrafts();
});

// Methods
// Methods
const fetchCategories = async () => {
  try {
    loading.value = true;
    // Dispatch the Vuex action to fetch categories
    await store.dispatch("NewCategory/fetchCategories");
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    loading.value = false;
  }
};
const fetchUserDrafts = async () => {
  try {
    const response = await DraftService.userDrafts(loggedInUser.value._id);
    userDrafts.value = response.status === 200 ? response.data.data : [];
  } catch (error) {
    console.error("Error fetching drafts:", error);
    userDrafts.value = [];
  }
};

// const selectCategory = async (category) => {
//   console.log("Selected category:", category);
//   store.dispatch("NewCategory/selectCategory", category);

//   // Fetch subcategories for the selected category
//   await store.dispatch("NewCategory/fetchSubCategories", category.slug);

//   // Navigate to PickSubCategory
//   router.push({ name: "PickSubCategory", params: { subcategory: category.slug } });
// };

async function selectCategory(cat) {
  // mark it so the template swaps to sub-grid
  if (cat.slug === "jobs") {
    picked.value = cat;
    showSubs.value = true;

    // save in Vuex so your module can fetch
    store.dispatch("NewCategory/selectCategory", cat);

    // pull exactly the two job subcats from your DB/API
    await store.dispatch("NewCategory/fetchSubCategories", cat.id);
  } else {
    // your normal navigation for non-jobs
    store.dispatch("NewCategory/selectCategory", cat);
    router.push({
      name: "PickSubCategoryForJob",
      params: { subcategory: cat.slug },
    });
  }
}

const selectDraftAndNavigate = (draft) => {
  store.dispatch("category/setCategory", draft.category);
  store.dispatch("category/setDraft", draft);
  const encodedCategoryName = encodeURIComponent(draft.category.name);
  router.push(`/create-listing/${encodedCategoryName}`);
};

const deleteDraft = async (draft) => {
  try {
    const response = await DraftService.delete(draft);
    if (response.status === 200) {
      userDrafts.value = userDrafts.value.filter((d) => d.id !== draft.id);
    }
  } catch (error) {
    console.error("Error deleting draft:", error);
  }
};

const logoRoute = () => {
  router.push("/");
};

function
 selectSubcategory(sub) {
  store.dispatch("NewCategory/selectSubCategory", sub);
  router.push({
    name: "GeneralListingSignUp",
    params: {
      categorySlug: picked.value.slug,
      subcategorySlug: sub.slug || sub.name.toLowerCase().replace(/\s+/g, "-"),
    },
  });
}


function goToHiring() {
  // dispatch into Vuex if you still need subcategory selected
  const jobSub = subcategories.value[0]
  store.dispatch('NewCategory/selectSubCategory', jobSub)

  // navigate to your groups list (uses the route name and props you set up)
  router.push({
    name: 'GeneralGroupsListComponentForJob',
    params: { subcategorySlug: jobSub.slug || slugify(jobSub.name) },
    query: { category: picked.value.slug }
  })

}

function goToJobSeekers() {
  // dispatch into Vuex if you still need subcategory selected
  const jobSub = subcategories.value[1]
  store.dispatch('NewCategory/selectSubCategory', jobSub)

  // navigate to your groups list (uses the route name and props you set up)
  router.push({
    name: 'GeneralGroupsListComponentForJob',
    params: { subcategorySlug: jobSub.slug || slugify(jobSub.name) },
    query: { category: picked.value.slug }
  })
}
</script>

<style scoped>
/* Style for main content area */
.main-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Transparent button backgrounds */
.v-btn::before {
  background-color: transparent;
}

.job-sub-item {
  transition: color 0.2s ease;
  cursor: pointer;
}
.job-sub-item:hover {
  color: #ff0000; /* or your theme’s red: var(--v-error-base) */
}
</style>
